<script lang="ts">
</script>

<div class="answer-row-with-number full-w margin-bottom-5px">
    <slot></slot>
</div>
